import type { ReceiptTemplate } from '../schema';

export const paypalTemplate: ReceiptTemplate = {
  id: 'paypal',
  name: 'PayPal Receipt',
  brand: 'PAYPAL',
  description: 'Digital payment receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'paypal-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 120,
        logoHeight: 50,
        businessName: 'PayPal',
        businessNameFontSize: 24,
        addressLines: [
          'Payment Receipt',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'paypal-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Transaction ID:\n8X472910AB284719C\n\nDate: January 4, 2026\nTime: 14:23:41 PST',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'paypal-parties',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'From: mike.wazowski@email.com\nTo: james.sullivan@store.com',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'paypal-desc',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Description:\nPayment for services',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'paypal-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 40,
        labelAlignment: 'left',
        lines: [
          { id: 'paypal-amount', label: 'Amount', value: '150.00', isBold: false, isLarge: false },
          { id: 'paypal-fee', label: 'Fee', value: '0.00', isBold: false, isLarge: false },
          { id: 'paypal-total', label: 'Total', value: '150.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'paypal-funding',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Funding Source:\nVisa x-4144\nPayPal Balance: $0.00',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'paypal-status',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Status: COMPLETED',
        fontSize: 14,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'paypal-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Questions? Visit paypal.com/help\nor call 1-888-221-1161',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

